import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ReactNode, memo } from 'react';
import { Pressable, StyleProp, View, ViewStyle } from 'react-native';

/** The white card of the AI pages: soft border, soft shadow. */
export const BiSurfaceCard = memo(
  ({
    children,
    style,
    onPress,
    accessibilityLabel,
  }: {
    children: ReactNode;
    style?: StyleProp<ViewStyle>;
    onPress?: () => void;
    accessibilityLabel?: string;
  }) => {
    const { rpx } = useResponsiveContext();
    const card: ViewStyle = {
      backgroundColor: aiColors.card,
      borderRadius: rpx(14),
      borderWidth: 1,
      borderColor: aiColors.border,
      shadowColor: '#0F172A',
      shadowOpacity: 0.06,
      shadowRadius: 6,
      shadowOffset: { width: 0, height: 2 },
      elevation: 2,
    };
    if (!onPress) return <View style={[card, style]}>{children}</View>;
    return (
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={accessibilityLabel}
        onPress={onPress}
        style={({ pressed }) => [card, style, pressed && { opacity: 0.85 }]}
      >
        {children}
      </Pressable>
    );
  },
);
